import type { AxiosResponse } from 'axios';
import apiClient from './apiClient';

export default async function sendDelete(path: string, id: string): Promise<AxiosResponse> {
  return apiClient.delete(`/${path}/${id}`);
}
